import {
  AllegroReturnPolicies,
  AllegroReturnPolicy,
  AllegroReturnPolicyAvailabilityRange,
  AllegroReturnPolicyReturnCostCoveredBy,
} from './returnPolicyTypes';

export const mockAllegroReturnPolicy: AllegroReturnPolicy = {
  id: 'd1cbcd9e-6042-4b1b-8e4f-3ba00d94ed32',
  seller: {
    id: '12345',
  },
  name: 'Standardní reklamační podmínky',
  availability: {
    range: AllegroReturnPolicyAvailabilityRange.FULL,
  },
  withdrawalPeriod: 'P14D',
  returnCost: {
    coveredBy: AllegroReturnPolicyReturnCostCoveredBy.BUYER,
  },
  address: {
    name: 'Sklad Allegro',
    street: 'Václavské náměstí 1',
    postCode: '110 00',
    city: 'Praha',
    countryCode: 'CZ',
  },
  contact: {
    phoneNumber: '+420601123458',
    email: 'returns@example.cz',
  },
  options: {
    cashOnDeliveryNotAllowed: false,
    freeAccessoriesReturnRequired: false,
    refundLoweredByReceivedDiscount: false,
    businessReturnAllowed: true,
    collectBySellerOnly: false,
  },
};

export const mockGetAllegroReturnPolicies: AllegroReturnPolicies = {
  returnPolicies: [
    {
      ...mockAllegroReturnPolicy,
      id: 'd1cbcd9e-6042-4b1b-8e4f-3ba00d94ed32',
      name: 'Return policy 1',
    },
    {
      ...mockAllegroReturnPolicy,
      id: '6f3d8c59-0620-4a61-9e99-c369b761e83e',
      name: 'Return policy 2',
    },
    {
      ...mockAllegroReturnPolicy,
      id: 'a094bcba-b9de-4272-8274-9d91149ebd0e',
      name: 'Return policy 3',
    },
    {
      ...mockAllegroReturnPolicy,
      id: '2950b2f9-6b97-4d9f-8225-aa291e613a45',
      name: 'Return policy 4',
    },
    {
      ...mockAllegroReturnPolicy,
      id: '3612966d-8268-45e2-946e-f088aa86a3c5',
      name: 'Return policy 5',
    },
  ],
  count: 5,
};
